import React from 'react';
import GeneratorBase from './GeneratorBase';

const HashtagGenerator = () => {
  const fields = [
    {
      name: 'content',
      label: 'Content',
      type: 'textarea',
      placeholder: 'Paste your post content here...',
      rows: 6,
      required: true
    },
    {
      name: 'keywords',
      label: 'Keywords',
      type: 'text',
      placeholder: 'e.g., branding, marketing, business growth',
      required: true
    }
  ];

  return (
    <GeneratorBase
      title="Hashtag Generator"
      description="Generate relevant LinkedIn and Instagram hashtags based on your content and keywords. Avoids spammy tags and focuses on engagement."
      fields={fields}
      apiEndpoint="hashtags"
      saveDraftEndpoint="hashtags"
    />
  );
};

export default HashtagGenerator;
